import Vue from 'vue'
import Router from 'vue-router'
import Inicio from './components/Inicio'
import AssinarPresenca from './components/assinarpresenca'
import ListarInscritos from './components/listarinscritos'
import ListarPresencas from './components/listarpresencas'
import ListarPresencasPorPalestra from './components/listarpresencasporpalestra'
import ListarPresencasPorUsuario from './components/listarpresencasporusuario'
import ListarPresencasPorUsuarioDetalhado from './components/listarpresencasporusuariodetalhado'
import ListarUsuariosCertificados from './components/listarpresencasporusuariodetalhadoCSV'
import MenuRelatorios from './components/menurelatorios'

Vue.use(Router)

export default new Router({
    mode: 'hash',
    routes: [
        {
            path: '/',
            component: Inicio,
            name: 'inicio'
        },
        {
            path: '/listarrelatorios',
            component: MenuRelatorios,
            name: 'relatorios'
        },
        {
            path: '/listarinscritos',
            component: ListarInscritos,
            name: 'inscritos'
        },
        {
            path: '/listarpresencas',
            component: ListarPresencas,
            name: 'presencas'
        },
        {
            path: '/listarpresencasporpalestra',
            component: ListarPresencasPorPalestra,
            name: 'presencasporpalestra'
        },
        {
            path: '/listarpresencasporusuario',
            component: ListarPresencasPorUsuario,
            name: 'presencasporusuario'
        },
        {
            path: '/listarpresencasporusuariodetalhado',
            component: ListarPresencasPorUsuarioDetalhado,
            name: 'presencasporusuariodetalhado'
        },
        {
            path: '/exportarCertificados',
            component: ListarUsuariosCertificados,
            name: 'exportarcertificados'
        },
        {
            path: '/assinarpresenca/:id',
            component: AssinarPresenca,
            name: 'presencaparams',
            props: { id: true }
        }
    ]
})